var angular = require("angular");
var template = require("./organisationUsers.pug");
require("../edit-btn");
require("../inline-edit-btn");
require("../inline-form");
var _ = require("underscore");
var Promise = require("bluebird");

angular.module("app.directives")
  .directive("organisationUsers", function($rootScope, ngDialog) {
    return {
      restrict: "E",
      scope: {
        getUsers: "=",
        getClaims: "=",
        getInvites: "=",
        updateClaims: "&",
        inviteUser: "&",
        removeUser: "&",
        removeUserInvite: "&",
        updateUserNumber: "&",
        updateUserOrganisationPosition: "&?",
        updateUserFinanceContact: "&?",
        canEdit: "="
      },

      template: template,
      link: function (scope) {
        scope.users = scope.getUsers;
        scope.permissions = scope.getClaims;
        scope.displayFinanceContact = (scope.updateUserFinanceContact != null);
        scope.updateUser = function(user) {
          var promises = [scope.updateClaims({ userArg: user }), scope.updateUserNumber({ userArg: user })];
          if (scope.updateUserOrganisationPosition) {
            promises.push(scope.updateUserOrganisationPosition({ userArg: user }));
          }
          if (scope.updateUserFinanceContact) {
            scope.updateFinanceContactSaved(user);
            promises.push(scope.updateUserFinanceContact({ userArg: user }));
          } 
          return Promise.all(promises);
        };

        scope.updateFinanceContactSaved = function(user) {
          if (user.isFinanceContact) {
            scope.users.forEach(function (aUser){
              aUser.isFinanceContactSaved = user === aUser;
            });
          } else {
            user.isFinanceContactSaved = user.isFinanceContact;
          }
        };

        scope.inviteNewMember = function(request) {
          email = request.email;
          request.email = null;
          //invite user (parent func)
          return scope.inviteUser({ emailArg: email });
        };
        scope.removeInvite = function(invite) {
          var dialog = ngDialog.open({
            template: require("./dialogs/removeInvite.pug")(),
            controller: require("./dialogs/removeInvite"),
            controllerAs: "vm",
            plain: true,
            disableAnimation: true,
            data: {
              email: invite.email,
            }
          });
          dialog.closePromise.then(function(data) {
            if (data.value.action == "submit") {
              var i = scope.getInvites.indexOf(invite);
              if (i != -1) {
                scope.pending.splice(i, 1);
              }
              return scope.removeUserInvite({ idArg: invite.id });
            }
          });
        };
        scope.removeMember = function(user) {
          var i = scope.getUsers.indexOf(user);
          if (i != -1) {
            scope.users.splice(i, 1);
          }
          return scope.removeUser({ userArg: user });
        };
        scope.$watch("getUsers", function(value) {
          if (value) {
            scope.users = value.map(function(user) {
              var id = user.id.replace(/\-/g, "");
              user.isSelf = $rootScope.auth.user_id == id;
              user.isFinanceContactSaved = user.isFinanceContact;
              return user;
            });
            updateClaims();
          }
        });

        scope.$watch("getClaims", function(value) {
          if (value) {
            scope.permissions = value;
            updateClaims();
          }
        });

        scope.$watch("getInvites", function(value) {
          if (value) {
            scope.pending = value;
          }
        });

        function updateClaims() {
          //have to cycle through all users/permissions
          _.each(scope.users, function(user) {
            user.permissions = [];
            _.each(scope.permissions, function(perm) {
              //initialise
              perm.isSelected = false;
              perm.isChanged = false;
              _.each(user.claims, function(claim) {
                if (perm.value == claim.type) {
                  //change if found
                  perm.isSelected = true;
                }
              });
              user.permissions.push(_.clone(perm));
            });
          });
        }

        scope.changeUserPermission = function(permission) {
          var cNewValue = !permission.isChanged;
          permission.isChanged = cNewValue;
        };
      }
    };
  });
